import Markdown from "@components/Markdown";
import { Button, Divider, Modal } from "@material-ui/core/";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
    },
    paper: {
      position: "absolute",
      maxWidth: 472,
      minWidth: 250,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      border: "none",
      padding: theme.spacing(3, 3, 3),
      outline: "none",
      borderRadius: "4px",
    },
    title: {
      color: theme.palette.primary.dark,
    },
  })
);
//onsubmit: check als echte mail, close modal en popup succesvol
type DisclaimerModalProps = {
  setDisclaimerModalOpen: any;
  disclaimerModalOpen: boolean;
  text: string;
  closeButtonText: string;
};
const DisclaimerModal = (props: DisclaimerModalProps) => {
  const classes = useStyles();
  return (
    <div>
      <Modal
        open={props.disclaimerModalOpen}
        onClose={() => {
          props.setDisclaimerModalOpen(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        <div className={classes.paper}>
          <Markdown>{props.text}</Markdown>
          <Divider />
          <br />
          <Button
            style={{ display: "block", marginLeft: "auto" }}
            color="secondary"
            variant="contained"
            onClick={() => {
              props.setDisclaimerModalOpen(false);
            }}
          >
            {props.closeButtonText}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DisclaimerModal;
